import React, { useEffect, useState } from "react";
import { Alert, Button, Upload } from "antd";
import { Box, CircularProgress } from "@mui/material";
import { InboxOutlined } from "@ant-design/icons";
import { ModalService } from "../../styled";
import { uploadCertificado } from "../../../../../../../service/uploadService";
import { CiImport } from "react-icons/ci";

const { Dragger } = Upload;

export function ModalImportarCertificado({ fecharModalImportCertificado, fetchConsultar, info, numSolicitacao, dadosCliente, setdadosCliente }) {
  const [loading, setLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(true);
  const [fileList, setFileList] = useState([]); // Armazena o arquivo selecionado

  useEffect(() => {
    console.log(numSolicitacao, info.clienteId)
  }, []);


  const handleFileChange = ({ file }) => {
    setFileList([file]); // Armazena o arquivo selecionado no estado
    setIsAlert(false);
  };

  const enterLoading = async () => {
    console.log("Arquivo:", fileList);
    if (!fileList.length) {
      setIsAlert(true); // Exibe o alerta se nenhum arquivo for selecionado
      return;
    }
    
    setLoading(true);
    try {
      // Chama o serviço de upload passando o arquivo selecionado
      const uploadOptions = uploadCertificado(info.clienteId, numSolicitacao);
      await uploadOptions.customRequest({ file: fileList[0], onSuccess: () => {}, onError: () => {} });
      
      setdadosCliente((prevState) => ({
        ...prevState,
        certificadoTipo: "",
        certificadoSenha: "",
        certificadoDataExpiracao: "",
        dataPedidoSN: ""
      }));

      

      //fetchConsultar();

    } catch (error) {
      console.error("Erro ao atualizar dados:", error);
    } finally {
      setLoading(false);
      fecharModalImportCertificado();
    }
  };

  return (
    <>
      <ModalService>
        <div className="barra">
          <div className="displayFlex">
            <div className="icon-font-center"><CiImport/></div>
            <div className="title">
              <span> Carregar Arquivo</span>
            </div>
            <div className="btn-close">
              <span className="close" onClick={fecharModalImportCertificado}>
                ×
              </span>
            </div>
          </div>
        </div>

        <div className="padding-10-container">
          <div className="container">
            <strong className="font-strong">Instruções</strong>
            <br />
           
            <label className="font">Selecione o Certificado Digital do cliente.</label>


            <div style={{margin: "10px 0"}}>
            {isAlert && (
              <Alert
              message="Atenção"
              description="É necessário importar o certificado antes de proseguir"
              type="error"
              showIcon
            />
            )}
            </div>
          </div>
          {loading[0] ? (
            <div className="margin-0-auto">
              <Box sx={{ display: "flex" }}>
                <CircularProgress />
              </Box>
            </div>
          ) : (
            <div>
              <div className="padding-5">
                <Dragger 
                  beforeUpload={() => false}
                  onChange={handleFileChange}
                  fileList={fileList}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Clique ou arraste o arquivo aqui
                  </p>
                  <p className="ant-upload-hint">
                    Suporte para upload de um arquivo. Apenas PDFs permitidos.
                  </p>
                </Dragger>
                <br />

                <div className="float">
                  <Button type="primary" className="color" loading={loading}
                      onClick={enterLoading}>
                    Carregar
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </ModalService>
    </>
  );
}

export default ModalImportarCertificado;
